// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { ChangePassword2Data, ChangePassword2Errors, ChangePassword2Responses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, CreateApiKey2Data, CreateApiKey2Responses, CreateApiKeyData, CreateApiKeyResponses, CreateGroup2Data, CreateGroup2Errors, CreateGroup2Responses, CreateGroupData, CreateGroupErrors, CreateGroupResponses, CreateMetricsConfig2Data, CreateMetricsConfig2Errors, CreateMetricsConfig2Responses, CreateMetricsConfigData, CreateMetricsConfigErrors, CreateMetricsConfigResponses, CreateUser2Data, CreateUser2Errors, CreateUser2Responses, CreateUserData, CreateUserErrors, CreateUserResponses, DeactivateApiKey2Data, DeactivateApiKey2Errors, DeactivateApiKey2Responses, DeactivateApiKeyData, DeactivateApiKeyErrors, DeactivateApiKeyResponses, DebugHeaders2Data, DebugHeaders2Responses, DebugHeadersData, DebugHeadersResponses, DeleteGroup2Data, DeleteGroup2Errors, DeleteGroup2Responses, DeleteGroupData, DeleteGroupErrors, DeleteGroupResponses, DeleteMetricsConfig2Data, DeleteMetricsConfig2Errors, DeleteMetricsConfig2Responses, DeleteMetricsConfigData, DeleteMetricsConfigErrors, DeleteMetricsConfigResponses, DeliberateErrorKaboomGetData, DeliberateErrorKaboomGetResponses, DisableUser2Data, DisableUser2Errors, DisableUser2Responses, DisableUserData, DisableUserErrors, DisableUserResponses, GetAssignableUsers2Data, GetAssignableUsers2Errors, GetAssignableUsers2Responses, GetAssignableUsersData, GetAssignableUsersErrors, GetAssignableUsersResponses, GetEditablePermissions2Data, GetEditablePermissions2Errors, GetEditablePermissions2Responses, GetEditablePermissionsData, GetEditablePermissionsErrors, GetEditablePermissionsResponses, GetGroup2Data, GetGroup2Errors, GetGroup2Responses, GetGroupData, GetGroupErrors, GetGroupResponses, GetMetricsConfig2Data, GetMetricsConfig2Errors, GetMetricsConfig2Responses, GetMetricsConfigData, GetMetricsConfigErrors, GetMetricsConfigResponses, GetPermissionsSchema2Data, GetPermissionsSchema2Responses, GetPermissionsSchemaData, GetPermissionsSchemaResponses, GetUser2Data, GetUser2Errors, GetUser2Responses, GetUserData, GetUserErrors, GetUserInfo2Data, GetUserInfo2Errors, GetUserInfo2Responses, GetUserInfoData, GetUserInfoErrors, GetUserInfoResponses, GetUserResponses, GetUsers2Data, GetUsers2Errors, GetUsers2Responses, GetUsersData, GetUsersErrors, GetUsersResponses, HealthCheckHealthyGetData, HealthCheckHealthyGetResponses, ListApiKeys2Data, ListApiKeys2Errors, ListApiKeys2Responses, ListApiKeys3Data, ListApiKeys3Responses, ListApiKeys4Data, ListApiKeys4Errors, ListApiKeys4Responses, ListApiKeysData, ListApiKeysResponses, ListGroupOptions2Data, ListGroupOptions2Errors, ListGroupOptions2Responses, ListGroupOptionsData, ListGroupOptionsErrors, ListGroupOptionsResponses, ListGroups2Data, ListGroups2Errors, ListGroups2Responses, ListGroupsData, ListGroupsErrors, ListGroupsResponses, ListGroupUsers2Data, ListGroupUsers2Errors, ListGroupUsers2Responses, ListGroupUsersData, ListGroupUsersErrors, ListGroupUsersResponses, ListMetricsConfigs2Data, ListMetricsConfigs2Errors, ListMetricsConfigs2Responses, ListMetricsConfigsData, ListMetricsConfigsErrors, ListMetricsConfigsResponses, LoginWithApiKey2Data, LoginWithApiKey2Responses, LoginWithApiKeyData, LoginWithApiKeyResponses, PatchUpdateMetricsConfig2Data, PatchUpdateMetricsConfig2Errors, PatchUpdateMetricsConfig2Responses, PatchUpdateMetricsConfigData, PatchUpdateMetricsConfigErrors, PatchUpdateMetricsConfigResponses, PutUpdateMetricsConfig2Data, PutUpdateMetricsConfig2Errors, PutUpdateMetricsConfig2Responses, PutUpdateMetricsConfigData, PutUpdateMetricsConfigErrors, PutUpdateMetricsConfigResponses, ReplaceMetricsConfigQuestionIds2Data, ReplaceMetricsConfigQuestionIds2Errors, ReplaceMetricsConfigQuestionIds2Responses, ReplaceMetricsConfigQuestionIdsData, ReplaceMetricsConfigQuestionIdsErrors, ReplaceMetricsConfigQuestionIdsResponses, ResetPassword2Data, ResetPassword2Errors, ResetPassword2Responses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, SendSignupEmail2Data, SendSignupEmail2Errors, SendSignupEmail2Responses, SendSignupEmailData, SendSignupEmailErrors, SendSignupEmailResponses, SyncSdgAlignedQuestions2Data, SyncSdgAlignedQuestions2Errors, SyncSdgAlignedQuestions2Responses, SyncSdgAlignedQuestionsData, SyncSdgAlignedQuestionsErrors, SyncSdgAlignedQuestionsResponses, UpdateGroup2Data, UpdateGroup2Errors, UpdateGroup2Responses, UpdateGroupData, UpdateGroupErrors, UpdateGroupPermissions2Data, UpdateGroupPermissions2Errors, UpdateGroupPermissions2Responses, UpdateGroupPermissionsData, UpdateGroupPermissionsErrors, UpdateGroupPermissionsResponses, UpdateGroupResponses, UpdateUser2Data, UpdateUser2Errors, UpdateUser2Responses, UpdateUserData, UpdateUserErrors, UpdateUserPermissions2Data, UpdateUserPermissions2Errors, UpdateUserPermissions2Responses, UpdateUserPermissionsData, UpdateUserPermissionsErrors, UpdateUserPermissionsResponses, UpdateUserResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class LabelsService {
    /**
     * List Group Options
     *
     * Returns all group IDs and names that can be used as labels.
     * e.g.:
     * {
     * "b0590b03-4166-435f-b35f-cbad52663067": "Group name",
     * "a2f68f6b-ac2a-432f-a6ef-2f78cf926084": "Another group name",
     * }
     */
    public static listGroupOptions<ThrowOnError extends boolean = true>(options?: Options<ListGroupOptionsData, ThrowOnError>): RequestResult<ListGroupOptionsResponses, ListGroupOptionsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListGroupOptionsResponses, ListGroupOptionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/labels/groups',
            ...options
        });
    }
    
    /**
     * List Group Options
     *
     * Returns all group IDs and names that can be used as labels.
     * e.g.:
     * {
     * "b0590b03-4166-435f-b35f-cbad52663067": "Group name",
     * "a2f68f6b-ac2a-432f-a6ef-2f78cf926084": "Another group name",
     * }
     */
    public static listGroupOptions2<ThrowOnError extends boolean = true>(options?: Options<ListGroupOptions2Data, ThrowOnError>): RequestResult<ListGroupOptions2Responses, ListGroupOptions2Errors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListGroupOptions2Responses, ListGroupOptions2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/labels/groups',
            ...options
        });
    }
}

export class GroupsService {
    /**
     * List Groups
     */
    public static listGroups<ThrowOnError extends boolean = true>(options?: Options<ListGroupsData, ThrowOnError>): RequestResult<ListGroupsResponses, ListGroupsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListGroupsResponses, ListGroupsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/groups',
            ...options
        });
    }
    
    /**
     * Create Group
     */
    public static createGroup<ThrowOnError extends boolean = true>(options: Options<CreateGroupData, ThrowOnError>): RequestResult<CreateGroupResponses, CreateGroupErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateGroupResponses, CreateGroupErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Group
     */
    public static deleteGroup<ThrowOnError extends boolean = true>(options: Options<DeleteGroupData, ThrowOnError>): RequestResult<DeleteGroupResponses, DeleteGroupErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteGroupResponses, DeleteGroupErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/groups/{group_id}',
            ...options
        });
    }
    
    /**
     * Get Group
     */
    public static getGroup<ThrowOnError extends boolean = true>(options: Options<GetGroupData, ThrowOnError>): RequestResult<GetGroupResponses, GetGroupErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetGroupResponses, GetGroupErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/groups/{group_id}',
            ...options
        });
    }
    
    /**
     * Update Group
     */
    public static updateGroup<ThrowOnError extends boolean = true>(options: Options<UpdateGroupData, ThrowOnError>): RequestResult<UpdateGroupResponses, UpdateGroupErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateGroupResponses, UpdateGroupErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/groups/{group_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Group Users
     */
    public static listGroupUsers<ThrowOnError extends boolean = true>(options: Options<ListGroupUsersData, ThrowOnError>): RequestResult<ListGroupUsersResponses, ListGroupUsersErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListGroupUsersResponses, ListGroupUsersErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/groups/{group_id}/users',
            ...options
        });
    }
    
    /**
     * Update Permissions
     *
     * Sets permissions for a group.
     */
    public static updateGroupPermissions<ThrowOnError extends boolean = true>(options: Options<UpdateGroupPermissionsData, ThrowOnError>): RequestResult<UpdateGroupPermissionsResponses, UpdateGroupPermissionsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateGroupPermissionsResponses, UpdateGroupPermissionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/groups/{group_id}/permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Groups
     */
    public static listGroups2<ThrowOnError extends boolean = true>(options?: Options<ListGroups2Data, ThrowOnError>): RequestResult<ListGroups2Responses, ListGroups2Errors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListGroups2Responses, ListGroups2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/groups',
            ...options
        });
    }
    
    /**
     * Create Group
     */
    public static createGroup2<ThrowOnError extends boolean = true>(options: Options<CreateGroup2Data, ThrowOnError>): RequestResult<CreateGroup2Responses, CreateGroup2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateGroup2Responses, CreateGroup2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Group
     */
    public static deleteGroup2<ThrowOnError extends boolean = true>(options: Options<DeleteGroup2Data, ThrowOnError>): RequestResult<DeleteGroup2Responses, DeleteGroup2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteGroup2Responses, DeleteGroup2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/groups/{group_id}',
            ...options
        });
    }
    
    /**
     * Get Group
     */
    public static getGroup2<ThrowOnError extends boolean = true>(options: Options<GetGroup2Data, ThrowOnError>): RequestResult<GetGroup2Responses, GetGroup2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetGroup2Responses, GetGroup2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/groups/{group_id}',
            ...options
        });
    }
    
    /**
     * Update Group
     */
    public static updateGroup2<ThrowOnError extends boolean = true>(options: Options<UpdateGroup2Data, ThrowOnError>): RequestResult<UpdateGroup2Responses, UpdateGroup2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateGroup2Responses, UpdateGroup2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/groups/{group_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Group Users
     */
    public static listGroupUsers2<ThrowOnError extends boolean = true>(options: Options<ListGroupUsers2Data, ThrowOnError>): RequestResult<ListGroupUsers2Responses, ListGroupUsers2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListGroupUsers2Responses, ListGroupUsers2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/groups/{group_id}/users',
            ...options
        });
    }
    
    /**
     * Update Permissions
     *
     * Sets permissions for a group.
     */
    public static updateGroupPermissions2<ThrowOnError extends boolean = true>(options: Options<UpdateGroupPermissions2Data, ThrowOnError>): RequestResult<UpdateGroupPermissions2Responses, UpdateGroupPermissions2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateGroupPermissions2Responses, UpdateGroupPermissions2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/groups/{group_id}/permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ServiceAccountsService {
    /**
     * List Api Keys
     *
     * List all API keys for the user's groups.
     */
    public static listApiKeys<ThrowOnError extends boolean = true>(options?: Options<ListApiKeysData, ThrowOnError>): RequestResult<ListApiKeysResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListApiKeysResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/services',
            ...options
        });
    }
    
    /**
     * Create Api Key
     *
     * Create a service account for either your own account, or someone with lesser or
     * equal permissions:
     * - Optional parameters:
     * - **email**: The service account email, which will change to serviceAccount-<email>
     * - **type**: The type of user from one of 'internal' or 'external'
     * - **role**: The role for the user from one of 'user', 'admin', or 'super-admin'
     * - N.B: Cannot create role/type with higher privileges than creating account
     * - **display_name**: Rarely used, but can be used to change the display name
     *
     * **N.B**: PLEASE STORE THIS TOKEN IN A SECURE PLACE AND TREAT IT LIKE A PASSWORD.
     */
    public static createApiKey<ThrowOnError extends boolean = true>(options?: Options<CreateApiKeyData, ThrowOnError>): RequestResult<CreateApiKeyResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).post<CreateApiKeyResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/services',
            ...options
        });
    }
    
    /**
     * List Group Api Keys
     */
    public static listApiKeys2<ThrowOnError extends boolean = true>(options: Options<ListApiKeys2Data, ThrowOnError>): RequestResult<ListApiKeys2Responses, ListApiKeys2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListApiKeys2Responses, ListApiKeys2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/services/{group_id}',
            ...options
        });
    }
    
    /**
     * Login With Api Key
     *
     * Login with a service account token.
     * Requires you to place the token in your header with "token" you got when you
     * created your service account.
     * Header format for **request**: "token: <token from creation>"
     * Returns json with id_token.
     * For further requests to the api, place this token in your authorization header:
     * "Authorization: Bearer <id_token>"
     *
     * N.B: Your token will expire an hour after creation
     */
    public static loginWithApiKey<ThrowOnError extends boolean = true>(options?: Options<LoginWithApiKeyData, ThrowOnError>): RequestResult<LoginWithApiKeyResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).post<LoginWithApiKeyResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ name: 'token', type: 'apiKey' }],
            url: '/api/v1/services/login',
            ...options
        });
    }
    
    /**
     * Deactivate Api Key Endpoint
     *
     * Deactivates an API key.
     */
    public static deactivateApiKey<ThrowOnError extends boolean = true>(options: Options<DeactivateApiKeyData, ThrowOnError>): RequestResult<DeactivateApiKeyResponses, DeactivateApiKeyErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeactivateApiKeyResponses, DeactivateApiKeyErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/services/{api_key_id}',
            ...options
        });
    }
    
    /**
     * List Api Keys
     *
     * List all API keys for the user's groups.
     */
    public static listApiKeys3<ThrowOnError extends boolean = true>(options?: Options<ListApiKeys3Data, ThrowOnError>): RequestResult<ListApiKeys3Responses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListApiKeys3Responses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/services',
            ...options
        });
    }
    
    /**
     * Create Api Key
     *
     * Create a service account for either your own account, or someone with lesser or
     * equal permissions:
     * - Optional parameters:
     * - **email**: The service account email, which will change to serviceAccount-<email>
     * - **type**: The type of user from one of 'internal' or 'external'
     * - **role**: The role for the user from one of 'user', 'admin', or 'super-admin'
     * - N.B: Cannot create role/type with higher privileges than creating account
     * - **display_name**: Rarely used, but can be used to change the display name
     *
     * **N.B**: PLEASE STORE THIS TOKEN IN A SECURE PLACE AND TREAT IT LIKE A PASSWORD.
     */
    public static createApiKey2<ThrowOnError extends boolean = true>(options?: Options<CreateApiKey2Data, ThrowOnError>): RequestResult<CreateApiKey2Responses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).post<CreateApiKey2Responses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/services',
            ...options
        });
    }
    
    /**
     * List Group Api Keys
     */
    public static listApiKeys4<ThrowOnError extends boolean = true>(options: Options<ListApiKeys4Data, ThrowOnError>): RequestResult<ListApiKeys4Responses, ListApiKeys4Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ListApiKeys4Responses, ListApiKeys4Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/services/{group_id}',
            ...options
        });
    }
    
    /**
     * Login With Api Key
     *
     * Login with a service account token.
     * Requires you to place the token in your header with "token" you got when you
     * created your service account.
     * Header format for **request**: "token: <token from creation>"
     * Returns json with id_token.
     * For further requests to the api, place this token in your authorization header:
     * "Authorization: Bearer <id_token>"
     *
     * N.B: Your token will expire an hour after creation
     */
    public static loginWithApiKey2<ThrowOnError extends boolean = true>(options?: Options<LoginWithApiKey2Data, ThrowOnError>): RequestResult<LoginWithApiKey2Responses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).post<LoginWithApiKey2Responses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ name: 'token', type: 'apiKey' }],
            url: '/services/login',
            ...options
        });
    }
    
    /**
     * Deactivate Api Key Endpoint
     *
     * Deactivates an API key.
     */
    public static deactivateApiKey2<ThrowOnError extends boolean = true>(options: Options<DeactivateApiKey2Data, ThrowOnError>): RequestResult<DeactivateApiKey2Responses, DeactivateApiKey2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeactivateApiKey2Responses, DeactivateApiKey2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/services/{api_key_id}',
            ...options
        });
    }
}

export class UsersService {
    /**
     * Reset Password
     *
     * Triggers a password reset email to be sent to the account associated by
     * `email`
     */
    public static resetPassword<ThrowOnError extends boolean = true>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/api/v1/users/reset-password',
            ...options
        });
    }
    
    /**
     * Send Signup Email
     *
     * If account for `email` exists, send it an account activation email.
     */
    public static sendSignupEmail<ThrowOnError extends boolean = true>(options: Options<SendSignupEmailData, ThrowOnError>): RequestResult<SendSignupEmailResponses, SendSignupEmailErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<SendSignupEmailResponses, SendSignupEmailErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/api/v1/users/send-signup-email',
            ...options
        });
    }
    
    /**
     * Change Password
     *
     * Use an account confirmation token to set the user's name and password.
     */
    public static changePassword<ThrowOnError extends boolean = true>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/api/v1/users/set-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get User Info
     *
     * Returns info for user authenticated by the auth token, or UNAUTHORIZED.
     * Note: UNAUTHORIZED can mean there is an issue with the token, or that the
     * user is not found.
     */
    public static getUserInfo<ThrowOnError extends boolean = true>(options?: Options<GetUserInfoData, ThrowOnError>): RequestResult<GetUserInfoResponses, GetUserInfoErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetUserInfoResponses, GetUserInfoErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/info',
            ...options
        });
    }
    
    /**
     * Permissions Schema
     */
    public static getPermissionsSchema<ThrowOnError extends boolean = true>(options?: Options<GetPermissionsSchemaData, ThrowOnError>): RequestResult<GetPermissionsSchemaResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetPermissionsSchemaResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/api/v1/users/permissions_schema',
            ...options
        });
    }
    
    /**
     * Get Editable Permissions
     *
     * Returns the subset of the permissions schema which the current user can
     * edit for the supplied user.
     */
    public static getEditablePermissions<ThrowOnError extends boolean = true>(options: Options<GetEditablePermissionsData, ThrowOnError>): RequestResult<GetEditablePermissionsResponses, GetEditablePermissionsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEditablePermissionsResponses, GetEditablePermissionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}/editable-permissions',
            ...options
        });
    }
    
    /**
     * Update Permissions
     *
     * Sets permissions for a user.
     *
     * You can pass a subset of permissions, in which case it only updates the
     * resources and actions provided, leaving others untouched.
     *
     * You can delete actions by explicitly setting them to null.
     */
    public static updateUserPermissions<ThrowOnError extends boolean = true>(options: Options<UpdateUserPermissionsData, ThrowOnError>): RequestResult<UpdateUserPermissionsResponses, UpdateUserPermissionsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateUserPermissionsResponses, UpdateUserPermissionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}/permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Users
     *
     * Returns a list of users ordered by display_name, based on the user's permissions.
     */
    public static getUsers<ThrowOnError extends boolean = true>(options?: Options<GetUsersData, ThrowOnError>): RequestResult<GetUsersResponses, GetUsersErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetUsersResponses, GetUsersErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users',
            ...options
        });
    }
    
    /**
     * Create User
     *
     * Creates a new user in:
     * - firebase (just display_name and email)
     * - our user_db
     * - big_query
     * Also dispatches a welcome email with an account confirmation code bound to
     * that user to use with the `/users/change-password` endpoint.
     *
     * For the user_transition_period this will accept a group_id and the user will
     * be added as non admin. We assume the user can only belong to one group.
     */
    public static createUser<ThrowOnError extends boolean = true>(options: Options<CreateUserData, ThrowOnError>): RequestResult<CreateUserResponses, CreateUserErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Assignable Users
     *
     * Returns a list of users who can have ingestion pipeline tasks assigned to them.
     */
    public static getAssignableUsers<ThrowOnError extends boolean = true>(options: Options<GetAssignableUsersData, ThrowOnError>): RequestResult<GetAssignableUsersResponses, GetAssignableUsersErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetAssignableUsersResponses, GetAssignableUsersErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/assignable-users/{step}/{theme}',
            ...options
        });
    }
    
    /**
     * Disable User
     *
     * Disables the account associated with user `user_id`.
     * Returns 404 if the user is missing from our database.
     */
    public static disableUser<ThrowOnError extends boolean = true>(options: Options<DisableUserData, ThrowOnError>): RequestResult<DisableUserResponses, DisableUserErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DisableUserResponses, DisableUserErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Get User
     *
     * Returns single user that matches the user id.
     */
    public static getUser<ThrowOnError extends boolean = true>(options: Options<GetUserData, ThrowOnError>): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Update User
     *
     * Update user identified by `user_id`.
     * You cannot change their role to be higher than your own.
     *
     * For the user_transition_period this will accept a group_id and the user will
     * be added as non admin. We assume the user can only belong to one group.
     */
    public static updateUser<ThrowOnError extends boolean = true>(options: Options<UpdateUserData, ThrowOnError>): RequestResult<UpdateUserResponses, UpdateUserErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateUserResponses, UpdateUserErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reset Password
     *
     * Triggers a password reset email to be sent to the account associated by
     * `email`
     */
    public static resetPassword2<ThrowOnError extends boolean = true>(options: Options<ResetPassword2Data, ThrowOnError>): RequestResult<ResetPassword2Responses, ResetPassword2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<ResetPassword2Responses, ResetPassword2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/users/reset-password',
            ...options
        });
    }
    
    /**
     * Send Signup Email
     *
     * If account for `email` exists, send it an account activation email.
     */
    public static sendSignupEmail2<ThrowOnError extends boolean = true>(options: Options<SendSignupEmail2Data, ThrowOnError>): RequestResult<SendSignupEmail2Responses, SendSignupEmail2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<SendSignupEmail2Responses, SendSignupEmail2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/users/send-signup-email',
            ...options
        });
    }
    
    /**
     * Change Password
     *
     * Use an account confirmation token to set the user's name and password.
     */
    public static changePassword2<ThrowOnError extends boolean = true>(options: Options<ChangePassword2Data, ThrowOnError>): RequestResult<ChangePassword2Responses, ChangePassword2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<ChangePassword2Responses, ChangePassword2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/users/set-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get User Info
     *
     * Returns info for user authenticated by the auth token, or UNAUTHORIZED.
     * Note: UNAUTHORIZED can mean there is an issue with the token, or that the
     * user is not found.
     */
    public static getUserInfo2<ThrowOnError extends boolean = true>(options?: Options<GetUserInfo2Data, ThrowOnError>): RequestResult<GetUserInfo2Responses, GetUserInfo2Errors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetUserInfo2Responses, GetUserInfo2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/info',
            ...options
        });
    }
    
    /**
     * Permissions Schema
     */
    public static getPermissionsSchema2<ThrowOnError extends boolean = true>(options?: Options<GetPermissionsSchema2Data, ThrowOnError>): RequestResult<GetPermissionsSchema2Responses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetPermissionsSchema2Responses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/users/permissions_schema',
            ...options
        });
    }
    
    /**
     * Get Editable Permissions
     *
     * Returns the subset of the permissions schema which the current user can
     * edit for the supplied user.
     */
    public static getEditablePermissions2<ThrowOnError extends boolean = true>(options: Options<GetEditablePermissions2Data, ThrowOnError>): RequestResult<GetEditablePermissions2Responses, GetEditablePermissions2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetEditablePermissions2Responses, GetEditablePermissions2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{user_id}/editable-permissions',
            ...options
        });
    }
    
    /**
     * Update Permissions
     *
     * Sets permissions for a user.
     *
     * You can pass a subset of permissions, in which case it only updates the
     * resources and actions provided, leaving others untouched.
     *
     * You can delete actions by explicitly setting them to null.
     */
    public static updateUserPermissions2<ThrowOnError extends boolean = true>(options: Options<UpdateUserPermissions2Data, ThrowOnError>): RequestResult<UpdateUserPermissions2Responses, UpdateUserPermissions2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateUserPermissions2Responses, UpdateUserPermissions2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{user_id}/permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Users
     *
     * Returns a list of users ordered by display_name, based on the user's permissions.
     */
    public static getUsers2<ThrowOnError extends boolean = true>(options?: Options<GetUsers2Data, ThrowOnError>): RequestResult<GetUsers2Responses, GetUsers2Errors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<GetUsers2Responses, GetUsers2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users',
            ...options
        });
    }
    
    /**
     * Create User
     *
     * Creates a new user in:
     * - firebase (just display_name and email)
     * - our user_db
     * - big_query
     * Also dispatches a welcome email with an account confirmation code bound to
     * that user to use with the `/users/change-password` endpoint.
     *
     * For the user_transition_period this will accept a group_id and the user will
     * be added as non admin. We assume the user can only belong to one group.
     */
    public static createUser2<ThrowOnError extends boolean = true>(options: Options<CreateUser2Data, ThrowOnError>): RequestResult<CreateUser2Responses, CreateUser2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateUser2Responses, CreateUser2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Assignable Users
     *
     * Returns a list of users who can have ingestion pipeline tasks assigned to them.
     */
    public static getAssignableUsers2<ThrowOnError extends boolean = true>(options: Options<GetAssignableUsers2Data, ThrowOnError>): RequestResult<GetAssignableUsers2Responses, GetAssignableUsers2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetAssignableUsers2Responses, GetAssignableUsers2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/assignable-users/{step}/{theme}',
            ...options
        });
    }
    
    /**
     * Disable User
     *
     * Disables the account associated with user `user_id`.
     * Returns 404 if the user is missing from our database.
     */
    public static disableUser2<ThrowOnError extends boolean = true>(options: Options<DisableUser2Data, ThrowOnError>): RequestResult<DisableUser2Responses, DisableUser2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DisableUser2Responses, DisableUser2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Get User
     *
     * Returns single user that matches the user id.
     */
    public static getUser2<ThrowOnError extends boolean = true>(options: Options<GetUser2Data, ThrowOnError>): RequestResult<GetUser2Responses, GetUser2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetUser2Responses, GetUser2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Update User
     *
     * Update user identified by `user_id`.
     * You cannot change their role to be higher than your own.
     *
     * For the user_transition_period this will accept a group_id and the user will
     * be added as non admin. We assume the user can only belong to one group.
     */
    public static updateUser2<ThrowOnError extends boolean = true>(options: Options<UpdateUser2Data, ThrowOnError>): RequestResult<UpdateUser2Responses, UpdateUser2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<UpdateUser2Responses, UpdateUser2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/users/{user_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class DebugService {
    /**
     * Headers
     */
    public static debugHeaders<ThrowOnError extends boolean = true>(options?: Options<DebugHeadersData, ThrowOnError>): RequestResult<DebugHeadersResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<DebugHeadersResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/api/v1/debug/headers',
            ...options
        });
    }
    
    /**
     * Headers
     */
    public static debugHeaders2<ThrowOnError extends boolean = true>(options?: Options<DebugHeaders2Data, ThrowOnError>): RequestResult<DebugHeaders2Responses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<DebugHeaders2Responses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/debug/headers',
            ...options
        });
    }
}

export class SyncService {
    /**
     * Sync Sdg Aligned Questions
     */
    public static syncSdgAlignedQuestions<ThrowOnError extends boolean = true>(options: Options<SyncSdgAlignedQuestionsData, ThrowOnError>): RequestResult<SyncSdgAlignedQuestionsResponses, SyncSdgAlignedQuestionsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<SyncSdgAlignedQuestionsResponses, SyncSdgAlignedQuestionsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/sync/sdg-aligned-questions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sync Sdg Aligned Questions
     */
    public static syncSdgAlignedQuestions2<ThrowOnError extends boolean = true>(options: Options<SyncSdgAlignedQuestions2Data, ThrowOnError>): RequestResult<SyncSdgAlignedQuestions2Responses, SyncSdgAlignedQuestions2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<SyncSdgAlignedQuestions2Responses, SyncSdgAlignedQuestions2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/sync/sdg-aligned-questions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class MetricConfigService {
    /**
     * List Metrics Configs
     */
    public static listMetricsConfigs<ThrowOnError extends boolean = true>(options?: Options<ListMetricsConfigsData, ThrowOnError>): RequestResult<ListMetricsConfigsResponses, ListMetricsConfigsErrors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListMetricsConfigsResponses, ListMetricsConfigsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics_config',
            ...options
        });
    }
    
    /**
     * Create Metrics Config
     */
    public static createMetricsConfig<ThrowOnError extends boolean = true>(options: Options<CreateMetricsConfigData, ThrowOnError>): RequestResult<CreateMetricsConfigResponses, CreateMetricsConfigErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateMetricsConfigResponses, CreateMetricsConfigErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics_config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Metrics Config
     */
    public static deleteMetricsConfig<ThrowOnError extends boolean = true>(options: Options<DeleteMetricsConfigData, ThrowOnError>): RequestResult<DeleteMetricsConfigResponses, DeleteMetricsConfigErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteMetricsConfigResponses, DeleteMetricsConfigErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics_config/{metrics_config_id}',
            ...options
        });
    }
    
    /**
     * Get Metrics Config
     */
    public static getMetricsConfig<ThrowOnError extends boolean = true>(options: Options<GetMetricsConfigData, ThrowOnError>): RequestResult<GetMetricsConfigResponses, GetMetricsConfigErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetMetricsConfigResponses, GetMetricsConfigErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics_config/{metrics_config_id}',
            ...options
        });
    }
    
    /**
     * Update Metrics Config
     */
    public static patchUpdateMetricsConfig<ThrowOnError extends boolean = true>(options: Options<PatchUpdateMetricsConfigData, ThrowOnError>): RequestResult<PatchUpdateMetricsConfigResponses, PatchUpdateMetricsConfigErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).patch<PatchUpdateMetricsConfigResponses, PatchUpdateMetricsConfigErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics_config/{metrics_config_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Metrics Config
     */
    public static putUpdateMetricsConfig<ThrowOnError extends boolean = true>(options: Options<PutUpdateMetricsConfigData, ThrowOnError>): RequestResult<PutUpdateMetricsConfigResponses, PutUpdateMetricsConfigErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<PutUpdateMetricsConfigResponses, PutUpdateMetricsConfigErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics_config/{metrics_config_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Replace Question Ids
     */
    public static replaceMetricsConfigQuestionIds<ThrowOnError extends boolean = true>(options: Options<ReplaceMetricsConfigQuestionIdsData, ThrowOnError>): RequestResult<ReplaceMetricsConfigQuestionIdsResponses, ReplaceMetricsConfigQuestionIdsErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<ReplaceMetricsConfigQuestionIdsResponses, ReplaceMetricsConfigQuestionIdsErrors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/metrics_config/replace/{old_question_id}/{new_question_id}',
            ...options
        });
    }
    
    /**
     * List Metrics Configs
     */
    public static listMetricsConfigs2<ThrowOnError extends boolean = true>(options?: Options<ListMetricsConfigs2Data, ThrowOnError>): RequestResult<ListMetricsConfigs2Responses, ListMetricsConfigs2Errors, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListMetricsConfigs2Responses, ListMetricsConfigs2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/metrics_config',
            ...options
        });
    }
    
    /**
     * Create Metrics Config
     */
    public static createMetricsConfig2<ThrowOnError extends boolean = true>(options: Options<CreateMetricsConfig2Data, ThrowOnError>): RequestResult<CreateMetricsConfig2Responses, CreateMetricsConfig2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<CreateMetricsConfig2Responses, CreateMetricsConfig2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/metrics_config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Metrics Config
     */
    public static deleteMetricsConfig2<ThrowOnError extends boolean = true>(options: Options<DeleteMetricsConfig2Data, ThrowOnError>): RequestResult<DeleteMetricsConfig2Responses, DeleteMetricsConfig2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).delete<DeleteMetricsConfig2Responses, DeleteMetricsConfig2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/metrics_config/{metrics_config_id}',
            ...options
        });
    }
    
    /**
     * Get Metrics Config
     */
    public static getMetricsConfig2<ThrowOnError extends boolean = true>(options: Options<GetMetricsConfig2Data, ThrowOnError>): RequestResult<GetMetricsConfig2Responses, GetMetricsConfig2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).get<GetMetricsConfig2Responses, GetMetricsConfig2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/metrics_config/{metrics_config_id}',
            ...options
        });
    }
    
    /**
     * Update Metrics Config
     */
    public static patchUpdateMetricsConfig2<ThrowOnError extends boolean = true>(options: Options<PatchUpdateMetricsConfig2Data, ThrowOnError>): RequestResult<PatchUpdateMetricsConfig2Responses, PatchUpdateMetricsConfig2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).patch<PatchUpdateMetricsConfig2Responses, PatchUpdateMetricsConfig2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/metrics_config/{metrics_config_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Metrics Config
     */
    public static putUpdateMetricsConfig2<ThrowOnError extends boolean = true>(options: Options<PutUpdateMetricsConfig2Data, ThrowOnError>): RequestResult<PutUpdateMetricsConfig2Responses, PutUpdateMetricsConfig2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<PutUpdateMetricsConfig2Responses, PutUpdateMetricsConfig2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/metrics_config/{metrics_config_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Replace Question Ids
     */
    public static replaceMetricsConfigQuestionIds2<ThrowOnError extends boolean = true>(options: Options<ReplaceMetricsConfigQuestionIds2Data, ThrowOnError>): RequestResult<ReplaceMetricsConfigQuestionIds2Responses, ReplaceMetricsConfigQuestionIds2Errors, ThrowOnError, 'data'> {
        return (options.client ?? client).put<ReplaceMetricsConfigQuestionIds2Responses, ReplaceMetricsConfigQuestionIds2Errors, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/metrics_config/replace/{old_question_id}/{new_question_id}',
            ...options
        });
    }
}

export class DefaultService {
    /**
     * Health Check
     */
    public static healthCheckHealthyGet<ThrowOnError extends boolean = true>(options?: Options<HealthCheckHealthyGetData, ThrowOnError>): RequestResult<HealthCheckHealthyGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<HealthCheckHealthyGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/healthy',
            ...options
        });
    }
    
    /**
     * Deliberate Error
     */
    public static deliberateErrorKaboomGet<ThrowOnError extends boolean = true>(options?: Options<DeliberateErrorKaboomGetData, ThrowOnError>): RequestResult<DeliberateErrorKaboomGetResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<DeliberateErrorKaboomGetResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            url: '/kaboom',
            ...options
        });
    }
}
